import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./DeliverySectionHeader.module.css";

export const DeliverySectionHeaderVariant = {
  current: "current",
  upcoming: "upcoming",
  past: "past",
};

/**
 * A full-width section label bar for Digital Delivery sections.
 */
export function DeliverySectionHeader({
  label,
  variant = DeliverySectionHeaderVariant.current,
}) {
  return (
    <div
      className={classNames(styles.bar, {
        [styles.current]: variant === DeliverySectionHeaderVariant.current,
        [styles.upcoming]: variant === DeliverySectionHeaderVariant.upcoming,
        [styles.past]: variant === DeliverySectionHeaderVariant.past,
      })}
    >
      {label}
    </div>
  );
}

DeliverySectionHeader.propTypes = {
  /**
   * Text shown inside the bar.
   */
  label: PropTypes.string.isRequired,

  /**
   * Controls the bar color.
   */
  variant: PropTypes.oneOf([
    DeliverySectionHeaderVariant.current,
    DeliverySectionHeaderVariant.upcoming,
    DeliverySectionHeaderVariant.past,
  ]),
};

export default DeliverySectionHeader;
